import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-index",
  "use": "icon-index-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-index\"><path d=\"M200.39,173H19.61l-1-3.21a95.37,95.37,0,1,1,182.7,0Zm-174-9H193.63a86.37,86.37,0,1,0-167.26,0Z\" /><rect x=\"105.5\" y=\"51.5\" width=\"9\" height=\"20.73\" /><rect x=\"18.7\" y=\"138.58\" width=\"20.73\" height=\"9\" /><rect x=\"180.57\" y=\"138.58\" width=\"20.73\" height=\"9\" /><rect x=\"100.31\" y=\"114.4\" width=\"65.86\" height=\"9\" transform=\"translate(-45.05 129.04) rotate(-45)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol